import React from 'react';
import { Grid, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface BasicDateRangePickerProps {
  start?: string;
  end?: string;
  onChange: (props: { start: string; end: string }) => void;
  direction?: 'horizontal' | 'vertical';
}

export const BasicDateRangePicker = ({ start, end, onChange, direction = 'horizontal' }: BasicDateRangePickerProps) => {
  const handleChangeStart = (newValue: Dayjs | null) => {
    if (newValue) {
      const newStart = newValue.clone().startOf('day');
      const newEnd = end && dayjs(end) < newStart ? newStart : dayjs(end);

      onChange({ start: dayjs(newStart).toISOString(), end: dayjs(newEnd).toISOString() });
    }
  };

  const handleChangeEnd = (newValue: Dayjs | null) => {
    if (newValue) {
      const newEnd = newValue.clone().endOf('day');
      const newStart = start && dayjs(start) > newEnd ? newEnd : dayjs(start);

      onChange({ start: dayjs(newStart).toISOString(), end: dayjs(newEnd).toISOString() });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Grid container rowSpacing={2} columnSpacing={2} alignItems="center">
        <Grid item sx={direction === 'horizontal' ? { flex: 1 } : { width: '100%' }}>
          <DatePicker
            label="Start"
            value={dayjs(start)}
            onChange={handleChangeStart}
            renderInput={(params: any) => <TextField {...params} size="small" fullWidth />}
          />
        </Grid>

        {direction === 'horizontal' && (
          <Grid item display={{ xs: 'none', sm: 'block' }}>
            to
          </Grid>
        )}

        <Grid item sx={direction === 'horizontal' ? { flex: 1 } : { width: '100%' }}>
          <DatePicker
            label="End"
            value={dayjs(end)}
            onChange={handleChangeEnd}
            renderInput={(params: any) => <TextField {...params} size="small" fullWidth />}
          />
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
};
